import styled from 'styled-components';
import * as colors from '../../../common/colorConstants';
import { touchedInputBorder } from './TicketFiltersSection.styles';

export const FilterBlock = styled.div`
  width: 100%;
  border-bottom: 1px solid ${colors.lightGray21};
  padding-bottom: 20px;
  margin-bottom: 20px;

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 16px;
  }
`;

export const FilterBlockTitle = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 1.45;
  color: ${colors.blue1};
  display: block;
  margin-bottom: 12px;
`;

export const FilterLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const FilterLineLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 1.45;
  color: ${colors.black4};
  min-width: 56px;
  width: 56px;
  flex-shrink: 0;
  text-align: left;
`;

export const PartialMatchLine = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 12px;
`;

export const PartialMatchLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 1.45;
  color: ${colors.black4};
`;

export const FilterInput = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  width: 100%;

  > * {
    width: 100%;
  }

  ${(props) => props.$isTouched && touchedInputBorder}
`;

export const IdentifierInput = styled.input`
  height: 25px;
  width: 100%;
  background-color: ${(props) => (props.disabled ? colors.lightGray7 : colors.white)};
  color: ${(props) => (props.disabled ? colors.inputGrey : colors.black4)};
  border: 1px solid ${colors.lightGray21};
  border-radius: 4px;
  padding: 0 8px;
  font-family: 'Roboto', sans-serif;
  font-weight: ${(props) => (props.disabled ? 500 : 400)};
  font-size: 11px;

  &:focus {
    outline: none;
    border-color: ${colors.blue1};
  }

  &::placeholder {
    color: ${colors.inputGrey};
    font-weight: 500;
  }
`;
